export const HOME = {
  hero: "hero-section",
  bookNowBtn: "book-now-btn",
  navBookBtn: "nav-book-now-btn",
  mobileMenuBtn: "mobile-menu-btn",
  whatsappBtn: "whatsapp-float-btn",
};

export const NAV = {
  home: "nav-home",
  rooms: "nav-rooms",
  facilities: "nav-facilities",
  gallery: "nav-gallery",
  explore: "nav-explore",
  restaurant: "nav-restaurant",
  about: "nav-about",
  blog: "nav-blog",
  contact: "nav-contact",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logoutBtn: "admin-logout-btn",
  createBtn: "admin-create-post-btn",
  postTitle: "admin-post-title",
  postExcerpt: "admin-post-excerpt",
  postContent: "admin-post-content",
  postCategory: "admin-post-category",
  postSave: "admin-post-save",
  postDelete: "admin-post-delete",
};

export const CONTACT = {
  name: "contact-name",
  email: "contact-email",
  message: "contact-message",
  submit: "contact-submit",
};
